import { Component, Inject, OnInit } from '@angular/core'
import { FormControl, FormGroup, UntypedFormGroup } from '@angular/forms'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Money } from '@app/features/scope-overview/model/money.model'
import { Discount } from '@core/model/discount.model'
import { ModalConfig } from '@core/model/modal-config.model'
import { ScopeUiInputComponent } from '@shared/components/ui-components/scope-ui-input/scope-ui-input.component'
import { SharedModule } from '@shared/shared.module'
import { formatMonetaryValue } from '@shared/utils/utils'
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material'

export interface AddEditDiscountModalData extends ModalConfig {
  discount?: Discount
  currencyCode: string
  maxDiscount: number
  onSubmit: (discount: Discount) => void
}

@Component({
  selector: 'add-edit-discount-modal',
  templateUrl: './add-edit-discount-modal.component.html',
  styleUrls: ['./add-edit-discount-modal.component.scss'],
  imports: [SharedModule, NgxDaterangepickerMd, ScopeUiInputComponent, MatButtonToggleModule],
  standalone: true,
})
export class AddEditDiscountModalComponent implements OnInit {
  modalForm: UntypedFormGroup
  amountTypeControl = new FormControl('AMOUNT')
  newDiscount: any

  constructor(@Inject(MAT_DIALOG_DATA) public data: AddEditDiscountModalData) {
    this.modalForm = new FormGroup({})
  }

  ngOnInit() {
    if (this.data.discount) {
      this.newDiscount = { ...this.data.discount }
      this.amountTypeControl.setValue(this.data.discount.type)
    } else {
      this.newDiscount = { description: '', value: 0, type: 'AMOUNT' }
    }
  }

  confirm() {
    this.newDiscount.type = this.amountTypeControl.value
    this.data.onSubmit(this.newDiscount)
  }

  protected readonly close = close

  isFormValid() {
    return this.newDiscount.description && this.newDiscount.value && this.newDiscount.value > 0.01
  }

  getAmountLabel() {
    if (this.data.maxDiscount) {
      return this.amountTypeControl.value == 'AMOUNT'
        ? `Amount (${this.data.currencyCode}) = (${this.getCurrentPercent()}%)`
        : `Percent = (${formatMonetaryValue(new Money(this.getCurrentAmount(), this.data.currencyCode))})`
    } else {
      return this.amountTypeControl.value == 'AMOUNT' ? `Amount (${this.data.currencyCode})` : `Percent`
    }
  }

  getCurrentPercent() {
    return parseFloat((((this.newDiscount.value || 0) / this.data.maxDiscount) * 100).toString()).toFixed(2)
  }

  getCurrentAmount() {
    return parseFloat((((this.newDiscount.value || 0) * this.data.maxDiscount) / 100).toString())
  }
}
